module.exports = __webpack_public_path__ + "img/ultra_2_04.88fc611e.jpg";